import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';

@Injectable()
export class AdditionalFrontUserInfoService {
  constructor(private http: HttpClient, private api: AppConfig) {}

  getAllAdditionalFrontUserInfo() {
    return this.http.get<object[]>(this.api.baseUrl + '/additionalFrontUserInfo/getAllAdditionalFrontUserInfo', this.api.jsonTokenHeaders);
  }

  getActiveAdditionalFrontUserInfo() {
    return this.http.get<{ id: number; title: string }[]>(this.api.baseUrl + '/additionalFrontUserInfo/getActiveAdditionalFrontUserInfo', this.api.jsonTokenHeaders);
  }

  getTableAdditionalFrontUserInfo() {
    return this.http.get<object[]>(this.api.baseUrl + '/additionalFrontUserInfo/getTableAdditionalFrontUserInfo', this.api.jsonTokenHeaders);
  }

  addAdditionalFrontUserInfo(data: object) {
    return this.http.post(this.api.baseUrl + '/additionalFrontUserInfo/addAdditionalFrontUserInfo', data, this.api.jsonTokenHeaders);
  }

  deleteAdditionalFrontUserInfo(id: number) {
    return this.http.delete(this.api.baseUrl + '/additionalFrontUserInfo/deleteAdditionalFrontUserInfo?id=' + id, this.api.jsonTokenHeaders);
  }
}
